var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTabFolder = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9175 2.5H8.92334L6.545 0.121663C6.46667 0.0433301 6.36083 0 6.25 0H2.91667C1.00833 0 0 1.00833 0 2.91667V11.25C0 13.1583 1.00833 14.1667 2.91667 14.1667H12.9167C14.825 14.1667 15.8333 13.1583 15.8333 11.25V5.41667C15.8342 3.50833 14.8258 2.5 12.9175 2.5ZM15.0008 11.25C15.0008 12.6908 14.3583 13.3333 12.9175 13.3333H2.91748C1.47665 13.3333 0.834147 12.6908 0.834147 11.25V2.91667C0.834147 1.47583 1.47665 0.833333 2.91748 0.833333H6.07829L8.45662 3.21167C8.53496 3.29 8.64079 3.33333 8.75163 3.33333H12.9183C14.3591 3.33333 15.0016 3.97583 15.0016 5.41667V11.25H15.0008Z",
    fill: "#4D6EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTabFolder);
export default ForwardRef;